var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"view treatment-faq"},[_c('view-title',{attrs:{"title":_vm.$t('message.treatment-faq.title')}}),_vm._l((_vm.faqs),function(section){return _c('f-a-q-section',{key:section._id,attrs:{"section":section}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }